module.exports = __webpack_public_path__ + "media/activity/pax-61d9c06a.svg";